<template>

  <div class="container">
  {{ msg  }}
  </div>
    
  </template>
  
  <script>
  export default {
    name: 'App',
    data () {
      return {
        msg: 'Welcome to Self Hiring APP!'
      }
    }
  }
  </script>
  
  <style>
  </style>